import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const props = {
  selected: {},
  products: [
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5692154.jpg',
      href: 'detail.php?id=1654335',
      title: 'Dual Carbs, H32/34 PDSI2/3',
      desc: 'Parts - General Parts',
      price: '$100/pr'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6802234.jpg',
      href: 'detail.php?id=1921935',
      title: 'Transmission Front mounting Bar, 72-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7509150.jpg',
      href: 'detail.php?id=2082703',
      title: 'Alt Pulley, 55 amp, 72-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$35'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7388859.jpg',
      href: 'detail.php?id=2055705',
      title: 'Speedometer, 76-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7388824.jpg',
      href: 'detail.php?id=2050110',
      title: 'Fuel Gauge, 68-72',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6421715.jpg',
      href: 'detail.php?id=1831488',
      title: 'Washer Bottle cover',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$10'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6688206.jpg',
      href: 'detail.php?id=1880118',
      title: 'Dome Light Switch, NOS',
      desc: 'Parts - Type 2/Bus - 1949-67',
      price: '$35'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6990038.jpg',
      href: 'detail.php?id=1895735',
      title: 'Gas Flap, 72-73 Only',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7509183.jpg',
      href: 'detail.php?id=2082712',
      title: 'Brake spreader/lever pieces, 72 only',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$50/pr'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6733925.jpg',
      href: 'detail.php?id=1906481',
      title: 'VW Dealers Booklet, circa 57-58',
      desc: 'Other - Literature/Manuals',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7570571.jpg',
      href: 'detail.php?id=2096279',
      title: 'Left Corner, 73-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$200'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7623075.jpg',
      href: 'detail.php?id=2108218',
      title: 'Dual Carb Air Cleaner Pedestal, 73-74',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25/set'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7747869.jpg',
      href: 'detail.php?id=2137731',
      title: 'Hot Air Blower Fan Relay, 72-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7903889.jpg',
      href: 'detail.php?id=2174029',
      title: 'Swing Lever, 68-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7734331.jpg',
      href: 'detail.php?id=2134594',
      title: 'Alternator, Lower Bracket, 72-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5277685.jpg',
      href: 'detail.php?id=1549654',
      title: 'Intake Air Distributor, fits 77-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$35'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7623091.jpg',
      href: 'detail.php?id=2108225',
      title: 'Rear Hatch Latch, 72-73',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$20'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7844426.jpg',
      href: 'detail.php?id=2160510',
      title: 'Charcoal Canister, 78-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7751864.jpg',
      href: 'detail.php?id=2108221',
      title: 'Dual Carbs mixture distributor, 72 only',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8010304.jpg',
      href: 'detail.php?id=2197502',
      title: 'Rear Cargo Hatch, 64-66',
      desc: 'Parts - Type 2/Bus - 1949-67',
      price: '$200'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6825011.jpg',
      href: 'detail.php?id=1927114',
      title: 'Crew/Double Cab Door Rod',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$15'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6825003.jpg',
      href: 'detail.php?id=1927112',
      title: 'Crew/Double Cab Door Latch, 69-73',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$50'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7923710.jpg',
      href: 'detail.php?id=2178368',
      title: 'Cover Plate under pedals, aka splash pan, 70-72',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$40'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7882882.jpg',
      href: 'detail.php?id=2169152',
      title: 'Drain Hose for fresh air box',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$15'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7844435.jpg',
      href: 'detail.php?id=2100248',
      title: 'Dasher Roof Rack',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$200'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7399028.jpg',
      href: 'detail.php?id=2058005',
      title: 'Brake Booster Check Valve, 71-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$10'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6957086.jpg',
      href: 'detail.php?id=1957042',
      title: 'Door Latch, Drivers side, 68 only',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$40'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7521180.jpg',
      href: 'detail.php?id=2085408',
      title: 'Rear Hatch Latch, 75-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$20'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7523003.jpg',
      href: 'detail.php?id=2085784',
      title: 'Dimmer Relay, 68-69',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7521314.jpg',
      href: 'detail.php?id=2085437',
      title: 'Steering column base cover, 75-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$15'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6391678.jpg',
      href: 'detail.php?id=1648026',
      title: 'Underdash heat distributor, 68-72',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8015019.jpg',
      href: 'detail.php?id=1754289',
      title: 'Overhead Air Vent End Cover/Grill',
      desc: 'Parts - Type 2/Bus - 1949-67',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5925622.jpg',
      href: 'detail.php?id=1712165',
      title: 'Oil Filter Bracket, 72-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$20'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5762322.jpg',
      href: 'detail.php?id=1671585',
      title: '411 Emblem',
      desc: 'Parts - Type 4 - 411/412',
      price: '$10'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6734155.jpg',
      href: 'detail.php?id=1669158',
      title: 'Engine Lid Latch/Handle',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$20'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5665577.jpg',
      href: 'detail.php?id=1648041',
      title: 'Back up / reverse light housing, 67-71',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$20'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5665555.jpg',
      href: 'detail.php?id=1648032',
      title: 'Underdash heat ducts, 73-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7743076.jpg',
      href: 'detail.php?id=1896773',
      title: 'Gas flap, 68-71',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6743877.jpg',
      href: 'detail.php?id=1908649',
      title: 'Control Valve, 1970',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$20'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6743893.jpg',
      href: 'detail.php?id=1908652',
      title: 'Steering column bracket with rubber bumper',
      desc: 'Parts - Type 2/Bus - 1949-67',
      price: '$20'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8026452.jpg',
      href: 'detail.php?id=2200981',
      title: 'Forward Heat Duct, Left, 72-74 & 79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$35'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8025110.jpg',
      href: 'detail.php?id=2200674',
      title: 'Dual Port Manifold Center Section',
      desc: 'Parts - General Parts',
      price: '$50'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8025103.jpg',
      href: 'detail.php?id=2200673',
      title: '40 hp Crank Pulley tin',
      desc: 'Parts - General Parts',
      price: '$35'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8025095.jpg',
      href: 'detail.php?id=2200671',
      title: 'Cooling Flaps for Dog House Fan Housing',
      desc: 'Parts - General Parts',
      price: '$100'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8025083.jpg',
      href: 'detail.php?id=2200668',
      title: 'Fuse box, 1972',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$40'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8006557.jpg',
      href: 'detail.php?id=2196673',
      title: 'Fuse box, 1971',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$40'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8006441.jpg',
      href: 'detail.php?id=2196647',
      title: 'Speedometer, 74-75',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8006452.jpg',
      href: 'detail.php?id=2196653',
      title: 'Air Vent Knob, w/ bracket',
      desc: 'Parts - Type 2/Bus - 1949-67',
      price: '$15'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8007292.jpg',
      href: 'detail.php?id=2196834',
      title: 'Sliding Door lower roller assembly',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$40'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8006420.jpg',
      href: 'detail.php?id=2196641',
      title: 'Front Trans Support, 68-71',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$35'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7921790.jpg',
      href: 'detail.php?id=2177972',
      title: 'Engine tin, rear left, 72-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$40'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7958472.jpg',
      href: 'detail.php?id=2186311',
      title: 'Jack with bag and lug wrench',
      desc: 'Parts - Type 2/Bus - Vanagon',
      price: '$45'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7826794.jpg',
      href: 'detail.php?id=2156335',
      title: 'Forward Heat Duct, Left, 75-78',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7745111.jpg',
      href: 'detail.php?id=2137055',
      title: 'Guide Channel , rear 68-72',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$15 ea'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7745107.jpg',
      href: 'detail.php?id=2137053',
      title: 'Dual Carb Mixture Distributor, 73-74',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7900171.jpg',
      href: 'detail.php?id=2173118',
      title: 'Combo Relay, 6V',
      desc: 'Parts - Type 1/Bug - 1958-67',
      price: '$35'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7744178.jpg',
      href: 'detail.php?id=2136850',
      title: 'Riviera curtain rails and clips',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$35'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7679234.jpg',
      href: 'detail.php?id=2121797',
      title: 'Fan Housing, 72-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$50'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7858446.jpg',
      href: 'detail.php?id=2121794',
      title: 'Balance Pipe, dual carbs',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$35'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/296602.jpg',
      href: 'detail.php?id=51856',
      title: 'USED BUS PARTS - TheBusCo.com',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: 'varies'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8014192.jpg',
      href: 'detail.php?id=2198388',
      title: 'Westy Rear Ashtray, 76-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$15'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8014152.jpg',
      href: 'detail.php?id=2198379',
      title: 'Exhaust Cross Over, 1979, California only',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$100'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8012973.jpg',
      href: 'detail.php?id=2198086',
      title: 'Air Cleaner Assembly, 73-74',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$60'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8012945.jpg',
      href: 'detail.php?id=2198080',
      title: 'Heat Outlets, L & R, 68-72',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$50/pr'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/8012939.jpg',
      href: 'detail.php?id=2198078',
      title: 'Striker Plate for engine lid, 66-67',
      desc: 'Parts - Type 2/Bus - 1949-67',
      price: '$20'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6323943.jpg',
      href: 'detail.php?id=1808985',
      title: 'Grill Vent, with screen, 73-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$50'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6319622.jpg',
      href: 'detail.php?id=1808000',
      title: 'Brake Reservoir, 69-70',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7431849.jpg',
      href: 'detail.php?id=2065537',
      title: 'Front Stabilizer / Anti Sway Bar',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$35'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6070470.jpg',
      href: 'detail.php?id=1748600',
      title: 'Tail light inside wire covers, 72-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$20/pr'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7694608.jpg',
      href: 'detail.php?id=2125191',
      title: 'Brake Line to Master Cylinder, 71-72',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$35'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5995959.jpg',
      href: 'detail.php?id=1720454',
      title: 'Wiper switch, 68-72',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5360457.jpg',
      href: 'detail.php?id=1570668',
      title: '12V Horn, 67-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$15'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5654643.jpg',
      href: 'detail.php?id=1645526',
      title: 'Oil Filler Tube, 72-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$20'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6975096.jpg',
      href: 'detail.php?id=1961177',
      title: 'Dormobile 12V socket and wiring',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7221153.jpg',
      href: 'detail.php?id=2017223',
      title: 'Steering Column Bracket, 68-72',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5362036.jpg',
      href: 'detail.php?id=1571059',
      title: 'Wiper Motor, 68-72 #211 955 113H',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$40'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7617377.jpg',
      href: 'detail.php?id=2106810',
      title: 'Inside Door Handles, 74-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$50/pr'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6746417.jpg',
      href: 'detail.php?id=1909226',
      title: 'Porsche 924 Service Manual',
      desc: 'Other - Literature/Manuals',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5348359.jpg',
      href: 'detail.php?id=1567646',
      title: 'door latch, drivers side, 74-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$25'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5762302.jpg',
      href: 'detail.php?id=1671580',
      title: 'Early Distributor',
      desc: 'Parts - General Parts',
      price: '$50'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5262794.jpg',
      href: 'detail.php?id=1545935',
      title: '79 Type 2 Owners Manual',
      desc: 'Other - Literature/Manuals',
      price: '$45'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7397394.jpg',
      href: 'detail.php?id=2057647',
      title: 'Shift Plate, 68-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$10'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/7397396.jpg',
      href: 'detail.php?id=2057648',
      title: 'Coil Bracket, 72-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$10'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/6092104.jpg',
      href: 'detail.php?id=1753820',
      title: 'Gas Heater Switch, Canadian, 65-66',
      desc: 'Parts - Type 1/Bug - 1958-67',
      price: '$50'
    },
    {
      src: 'https://www.thesamba.com/vw/classifieds/pix/5964407.jpg',
      href: 'detail.php?id=1722080',
      title: 'Engine Lid striker plate, 72-79',
      desc: 'Parts - Type 2/Bus - Bay Window - 1968-79',
      price: '$10'
    }
  ]
};
export default new Vuex.Store(vuexSimple({
  mutations: {
    addDescription(state, { item, value }) {
      item.description = value;
    },
    addShipping(state, { item, value }) {
      item.shipping = value;
    }
  },
  actions: {
    addDescription({ commit }, value) {
      commit('addDescription', value);
    },
    addShipping({ commit }, value) {
      commit('addShipping', value);
    }
  }
}, props));
function vuexSimple(options, props) {
  const { state = {}, mutations = {}, actions = {}, getters = {} } = options;
  options.state = state;
  options.mutations = mutations;
  options.actions = actions;
  options.getters = getters;
  Object.entries(props).forEach(([prop, initial]) => {
    state[prop] = state[prop] || initial;
    mutations[prop] = mutations[prop] || ((state, value) => (state[prop] = value));
    actions[prop] = actions[prop] || (({ commit }, value) => commit(prop, value));
    getters[prop] = getters[prop] || (state => state[prop]);
  });
  return options;
}
